import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="min-h-[60vh] flex items-center justify-center bg-background-50">
        <div className="text-center px-4">
          <div className="w-20 h-20 rounded-full bg-background-100 flex items-center justify-center mx-auto mb-6">
            <i className="ri-error-warning-line w-10 h-10 flex items-center justify-center text-foreground-400 text-3xl"></i>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">
            404
          </h1>
          <p className="mt-3 text-base md:text-lg text-foreground-600">
            抱歉，您访问的页面不存在
          </p>
          <p className="mt-1 text-sm text-foreground-500">
            可能是链接已失效，或页面已被移除
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-8 px-6 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            <i className="ri-home-line w-4 h-4 flex items-center justify-center"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}